import React from 'react';

export default function PhotoLightbox({ src, onClose }) {
  if (!src) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <button style={styles.closeBtn} onClick={onClose}>✕</button>
      <img src={src} alt="" style={styles.image} onClick={e => e.stopPropagation()} />
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.92)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 2000, padding: '1.5rem',
  },
  closeBtn: {
    position: 'absolute', top: '1.25rem', right: '1.25rem',
    background: 'rgba(255,255,255,0.1)', color: '#fff',
    width: '40px', height: '40px', borderRadius: '50%',
    fontSize: '1.2rem', cursor: 'pointer', border: 'none',
  },
  image: {
    maxWidth: '100%', maxHeight: '90vh', borderRadius: '8px',
    objectFit: 'contain',
  },
};
